export const EACCEPTED_DOCUMENT_FORMATS = '.doc,.docx,.txt,.pdf,.rtf'.split(',');
